import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp, Phone } from "lucide-react";
import { COMPANY } from "@/lib/site";

export default function BackToTop() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const toTop = () => {
        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.3 }}
                    className="fixed bottom-5 right-5 z-[60] flex flex-col gap-3"
                >
                    <a
                        href={COMPANY.phoneHref}
                        aria-label={`Call ${COMPANY.name} on ${COMPANY.phoneDisplay}`}
                        className="sm:hidden w-12 h-12 rounded-full bg-[#141414] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(0,0,0,0.3)]"
                    >
                        <Phone className="w-5 h-5" />
                    </a>
                    <button
                        data-testid="footer-back-to-top-button"
                        onClick={toTop}
                        aria-label="Back to top"
                        className="w-12 h-12 rounded-full bg-[#E85A1D] hover:bg-[#D24B10] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(232,90,29,0.4)] transition-colors duration-200"
                    >
                        <ArrowUp className="w-5 h-5" />
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
